import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show after 1.5s delay for better UX
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'essential_only');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-[900px] mx-auto bg-[#121316] text-white rounded-2xl p-5 shadow-2xl border border-white/10">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-xl bg-[#B89B5E]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
            <Cookie className="w-5 h-5 text-[#B89B5E]" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-sm mb-1">We value your privacy</h3>
            <p className="text-xs text-white/60 leading-relaxed">
              We use essential cookies for authentication and preferences, and optional analytics cookies to improve our service. 
              Read our <Link to="/privacy" className="text-[#B89B5E] underline hover:text-[#D4B36E]">Privacy Policy</Link> for details.
            </p>
          </div>
          <button onClick={() => setVisible(false)} className="text-white/40 hover:text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center justify-end gap-3 mt-4">
          <Button
            variant="ghost"
            size="sm"
            className="text-white/60 hover:text-white hover:bg-white/10 text-xs"
            onClick={handleDecline}
          >
            Essential Only
          </Button>
          <Button
            size="sm"
            className="bg-[#B89B5E] text-white hover:bg-[#A08A50] text-xs px-6"
            onClick={handleAccept}
          >
            Accept All
          </Button>
        </div>
      </div>
    </div>
  );
}
